import {CurrencySettings} from "PageBuilder/utils/CurrencySettings";


export class CurrencyUtils {
    public static GetInstance():CurrencyUtils{
        if((window as any).RNCurrencyUtils==null)
            (window as any).RNCurrencyUtils=new CurrencyUtils();
        return (window as any).RNCurrencyUtils;
    }


    public Config:CurrencySettings;

    public FormatValue(amount:number)
    {
        if(isNaN(amount))
            amount=0;
        let text=amount.toFixed(this.Config.NumberOfDecimals);
        var x = text.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        if(this.Config.ThousandSeparator!='') {
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + this.Config.ThousandSeparator + '$2');
            }
        }

        if(x2.length>0)
        {
            x2=x2.slice(1);
            x2=this.Config.DecimalSeparator+x2;
        }
        text= x1 + x2;
        if(this.Config.Position=='left')
            return this.Config.Symbol+text;
        if(this.Config.Position=='left_space')
            return this.Config.Symbol+' '+text;
        if(this.Config.Position=='right')
            return text+this.Config.Symbol;
        if(this.Config.Position=='right_space')
            return text+' '+this.Config.Symbol;

    }
}